import type { CompanyTableColumnDef } from '../types/company-table-column.types';

export function inferTableColumns(rows: readonly Record<string, unknown>[]): CompanyTableColumnDef[] {
  const first = rows[0];
  if (!first) return [];
  return Object.keys(first).map(key => ({ field: key, headerName: key, type: 'text' as const }));
}

export function resolveTableColumns(
  columns: readonly CompanyTableColumnDef[] | undefined,
  rows: readonly Record<string, unknown>[],
): CompanyTableColumnDef[] {
  if (columns && columns.length > 0) return [...columns];
  return inferTableColumns(rows);
}
